module.exports = __webpack_public_path__ + "static/desk-8be4af75f27007f4f1f61daeef57a2c2.jpg";